export const checkAndReloadWithExternalBrowserParam = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has("openExternalBrowser")) {
    urlParams.set("openExternalBrowser", "1");
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.location.href = newUrl;
    return true;
  }
  return false;
};
